import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { siteSettingsAPI } from '../services/api';

const SiteSettingsContext = createContext();

const defaultSettings = {
    phone: '+90 546 216 62 83',
    whatsapp: '905462166283',
    email: 'info@xn--atlyekirpi-fcb.com.tr',
    address: 'Hastane Mah. Bera Sok. No:22 D:1 Bodrum Kat Arnavutköy/İstanbul',
    instagram: '',
    twitter: '',
    linkedin: '',
    facebook: '',
    youtube: '',
    workingHours: 'Pazartesi - Cumartesi: 09:00 - 18:00',
    mapsEmbedUrl: '',
    marqueeItems: '["Kanvas Tablo","Çerçeveli Tablo","Modern Duvar Sanatı","Ücretsiz Kargo","Dekoratif Panolar"]'
};

export function SiteSettingsProvider({ children }) {
    const [settings, setSettings] = useState(defaultSettings);
    const [loaded, setLoaded] = useState(false);

    const refreshSettings = useCallback(async () => {
        try {
            const res = await siteSettingsAPI.getAll();
            setSettings({ ...defaultSettings, ...res.data });
        } catch (e) {
            console.error('Site settings fetch error:', e);
        }
        setLoaded(true);
    }, []);

    useEffect(() => {
        refreshSettings();
    }, [refreshSettings]);

    return (
        <SiteSettingsContext.Provider value={{ settings, loaded, refreshSettings }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}

export function useSiteSettings() {
    const context = useContext(SiteSettingsContext);
    if (!context) {
        return { settings: defaultSettings, loaded: false, refreshSettings: () => {} };
    }
    return context;
}
